import { CatalogoReadingDtoProps } from "./DTOs/CatalogoReadingDto"

export const adapterCatalogo = (
  catalogo: CatalogoReadingDtoProps
): CatalogoReadingDtoProps => ({
  id: catalogo?.id,
  cantidadArticulos: catalogo?.cantidadArticulos,
  categorias: catalogo?.categorias,
  ficheroId: catalogo?.ficheroId,
  imagenBase64: catalogo?.imagenBase64,
  imagenMediaType: catalogo?.imagenMediaType,
  nombre: catalogo?.nombre,
})
